import React from "react";
import companyLogo from "../../assets/logo.png";

function ForgotPasswordForm({ setForm }) {
  const setFormToLogin = () => {
    setForm("login");
  };

  const setFormToSignUp = () => {
    setForm("signup");
  };
  return (
    <div className="w-full md:w-2/5 bg-black text-white">
      <img src={companyLogo} alt="Company Logo" className="mb-8 p-20" />
      <div className="w-full flex flex-col justify-center items-center bg-black text-white">
        <div className="max-w-md w-full">
          <h2 className="text-3xl font-bold mb-8">Reset Password</h2>
          <form>
            <div className="mb-4">
              <label className="block mb-1" htmlFor="email">
                Email
              </label>
              <input
                type="email"
                id="email"
                className="w-full p-2 border border-gray-300 rounded-lg text-black"
              />
            </div>
            <button
              type="submit"
              className="w-full bg-[#2d9376] text-white py-2 px-4 rounded-lg hover:bg-green-600"
            >
              Reset Password
            </button>
            <div className="mt-4 text-center">
              Already have an account? &nbsp;
              <a
                href="#"
                className="text-[#2d9376] hover:underline"
                onClick={setFormToLogin}
              >
                Sign In
              </a>
            </div>
            <div className="mt-4 text-center">
              <a
                href="#"
                className="text-[#2d9376] hover:underline"
                onClick={setFormToSignUp}
              >
                Dont have an account yet? Create Account
              </a>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ForgotPasswordForm;
